import { get } from "src/services/HttpClient";

export async function getData(handler = () => { }, url, config, signal) {
    const result = await get(url, config, signal);
    if (result && result.statusCode == 200) {
        handler(result.data);
        return result.data;
    }
    return result;
}